var React = require('react');

function FlagTt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.725H8.828A8.829 8.829 0 010 414.897V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.793a8.83 8.83 0 01-8.829 8.828z","fill":"#ff4b55","key":0}),React.createElement("g",{"fill":"#f5f5f5","key":1},React.createElement("path",{"d":"M8.828 88.277c-2.387 0-4.535.967-6.124 2.506l359.228 332.942h26.483L26.483 88.277H8.828zM150.069 88.277h-26.483l361.931 335.448h17.655c2.387 0 4.535-.967 6.124-2.506L150.069 88.277z"})),React.createElement("path",{"fill":"#464655","d":"M26.483 88.277l361.931 335.448h97.103L123.586 88.277z","key":2})]);
}

FlagTt.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagTt;

FlagTt.default = FlagTt;
